import { GET_CHARGERS } from '../actions.type'
import { SET_CHARGERS } from '../mutations.type'
import ChargerService from '@/services/ChargerService'

const state = {
  chargers: [],
  chargerData: {}
}

const getters = {
  chargers: state => state.chargers.map(id => state.chargerData[id])
}

const actions = {
  [GET_CHARGERS]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      ChargerService.getChargers()
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(SET_CHARGERS, response.data.data)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [SET_CHARGERS]: (state, data) => {
    state.chargerData = {}
    data.forEach(charger => {
      charger.evseId = '';
      state.chargerData[charger.id] = charger
    });
    state.chargers = Object.keys(state.chargerData)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
